import { useEffect } from 'react';
import i18n from 'i18next';
import { useCurrentLocale } from './useCurrentLocale';
import { appLanguage } from '../store/LanguageStore';
import { langCodeToAppLanguage } from '../config/languages';

/**
 * Keeps the i18n instance, the LanguageStore signal and the <html lang>
 * attribute in sync with the language code coming from the URL.
 *
 * Mount this once at the top of the app (inside Router context).
 */
export const useLocaleSync = () => {
    const lang = useCurrentLocale();

    useEffect(() => {
        if (i18n.language !== lang) {
            i18n.changeLanguage(lang);
        }
        const appLang = langCodeToAppLanguage(lang);
        if (appLanguage.value !== appLang) {
            appLanguage.value = appLang;
        }
        if (typeof document !== 'undefined' && document.documentElement.lang !== lang) {
            document.documentElement.lang = lang;
        }
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem('appLanguage', appLang);
        }
    }, [lang]);
};
